import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from '../Context/auth';
import MenuLateral from "../Components/MenuPrincipal/MenuLateral";
import MovimentacaoForm from '../Components/MovimentacaoForm/MovimentacaoForm';
import '../Marcas/Marcas.css'; // Importa estilos padronizados

function EditarMovimentacao() {
    const { currentUser, appUserData } = useAuth();
    const { id } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [initialData, setInitialData] = useState(null);

    // Verifica permissão de edição
    useEffect(() => {
        if (appUserData && !appUserData['editar_movimentacoes']) {
            Swal.fire({
                icon: 'error',
                title: 'Acesso Negado',
                text: 'Você não tem permissão para editar movimentações.',
                confirmButtonColor: '#2185c6'
            }).then(() => {
                navigate('/app/home'); // Volta para a home
            });
        }
    }, [appUserData, navigate]);

    useEffect(() => {
        const fetchMovimentacaoData = async () => {
            if (!id) return;
            try {
                setLoading(true);
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/movimentacoes/${id}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) {
                    throw new Error('Movimentação não encontrada');
                }
                const data = await response.json();
                setInitialData(data);
            } catch (error) {
                Swal.fire('Erro', error.message, 'error');
                navigate('/app/movimentacoes');
            } finally {
                setLoading(false);
            }
        };
        fetchMovimentacaoData();
    }, [id, currentUser, navigate, setLoading, setInitialData]);

    const handleUpdate = async (formData) => {
        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/movimentacoes/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Falha ao atualizar movimentação');
            }

            Swal.fire('Sucesso!', 'Movimentação de estoque atualizada com sucesso!', 'success');
            navigate('/app/movimentacoes');
        } catch (error) {
            Swal.fire('Erro', error.message, 'error');
        }
    };

    return (
        <div className="marcas-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="marcas-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/movimentacoes')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="marcas-title m-0">
                            Editar <span className="highlight">Movimentação #{id}</span>
                        </h1>
                    </div>
                </div>
                <div className="marcas-content">
                    {loading ? (
                        <div className="text-center p-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Carregando...</span>
                            </div>
                        </div>
                    ) : (
                        <MovimentacaoForm
                            onSubmit={handleUpdate}
                            initialData={initialData}
                            isEditing={true}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default EditarMovimentacao;